import { ConfigurationEnumsService_enumsServiceGetGetEnum } from '@festina/unitlinkdatareplicator-general-types/unitlinkdatareplicator/hooks/ConfigurationEnumsService_enumsServiceGetGetEnum'

export const useFetchEnumValues =
  ConfigurationEnumsService_enumsServiceGetGetEnum.useSuspenseQuery
